import { render, staticRenderFns } from "./CampaignsDrafts.vue?vue&type=template&id=72d775bc&scoped=true"
import script from "./CampaignsDrafts.vue?vue&type=script&lang=js"
export * from "./CampaignsDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d775bc",
  null
  
)

export default component.exports